import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import FacebookIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';

const logoStyle = {
  width: '140px',
  height: 'auto',
};

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" mt={1}>
      {'Copyright © '}
      Szymon Bandel&nbsp;
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  return (
    <Container
  sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: { xs: 4, sm: 8 },
    py: { xs: 1, sm: 2 },
    textAlign: { sm: 'center', md: 'left' },
  }}
>
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      pt: { xs: 1, sm: 2 },
      width: '100%'
    }}
  >
    <div>
      <Copyright />
    </div>
    <Stack
      direction="row"
      justifyContent="left"
      spacing={1}
      useFlexGap
      sx={{
        color: 'text.secondary',
      }}
    >
      <IconButton
        color="inherit"
        href="mailto:bandelszymon@gmail.com"
        aria-label="Email"
        sx={{ alignSelf: 'center' }}
      >
        <EmailOutlinedIcon />
      </IconButton>
      <IconButton
        color="inherit"
        href="https://www.facebook.com/profile.php?id=100018678579069"
        aria-label="Facebook"
        sx={{ alignSelf: 'center' }}
      >
        <FacebookOutlinedIcon />
      </IconButton>
      <IconButton
        color="inherit"
        href="https://github.com/DonSimonio"
        aria-label="GitHub"
        sx={{ alignSelf: 'center' }}
      >
        <FacebookIcon />
      </IconButton>
      <IconButton
        color="inherit"
        href="https://www.linkedin.com/in/szymon-bandel-1346b225b/"
        aria-label="LinkedIn"
        sx={{ alignSelf: 'center' }}
      >
        <LinkedInIcon />
      </IconButton>
    </Stack>
  </Box>
</Container>

  );
}
